import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-loading',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="d-flex flex-column align-items-center justify-content-center text-center" 
         style="min-height: 200px;">
      <div class="spinner-border text-primary mb-3" 
           style="width: 3rem; height: 3rem;" 
           role="status">
        <span class="visually-hidden">Caricamento...</span>
      </div>
      <!-- <p class="text-muted fw-semibold mb-0">
        <i class="fas fa-hourglass-half me-2"></i>
        Caricamento...
      </p> -->
    </div>
  `,
  styles: []
})
export class LoadingComponent { }
